class AttachButton extends HTMLElement {
  connectedCallback() {
    if (this.input) return;

    this.input = document.createElement('input');
    this.input.type = 'file';
    this.input.hidden = true;
    this.input.multiple = true;

    this.appendChild(this.input);

    this.addEventListener('click', () => {
      this.input.click();
    });

    this.input.addEventListener('change', () => {
      this.dispatchEvent(
        new CustomEvent('attach:change', {
          bubbles: true,
          detail: { files: this.input.files },
        })
      );
    });
  }
}

customElements.define('attach-button', AttachButton);
